// Import your images
import Logo from './assets/img/Medengage-whiteLogo-3 1.png';
import HomeBanner from './assets/img/banner-image.jpeg';
import Metropolis from './assets/img/Final-Logo_280624_white-01 1.png';
import ScholorshipImage from './assets/img/scholorship-page.jpeg';
import ScholorVector from './assets/img/scholor-vector.png';
import Arrow from './assets/img/arrow.png';
import Dummy from './assets/img/dumm.jpeg';

import Academic from './assets/img/acedmic.png';
import Poster from './assets/img/poster.png';
import Publication from './assets/img/publication.png';
import Extra from './assets/img/extra.png';
import Community from './assets/img/community.png';
import StylishArrow from './assets/img/stylish-arrow.png';
import Play from './assets/img/play.png';
import Doctor from './assets/img/doctor.png';
import Facebook from './assets/img/facebook.png';
import LinkedIn from './assets/img/linkedin.png';
import Twitter from './assets/img/twitter.png';
import Instagram from './assets/img/instagram.png';
import Research from './assets/img/grant.png';
import Students from './assets/img/students.png';
import Aspirational from './assets/img/aspirational.png';
import Test1 from './assets/img/test1.jpg';
import Test2 from './assets/img/test2.jpg';
import Test3 from './assets/img/test3.jpg';
import Test4 from './assets/img/test4.jpg';
import Test5 from './assets/img/test5.jpg';
import Plus from './assets/img/plus.png';
import Minus from './assets/img/minus.png';
import Search from './assets/img/research.png';
import Doctors from './assets/img/doctors.png';
import Location from './assets/img/location.png';
import Internship from './assets/img/internship.png';
import Application from './assets/img/application.jpg';
import Signup from './assets/img/signup.png';
import Reset from './assets/img/reset.jpeg';
import Thanks from './assets/img/thankyou-banner.png';
import Observership from './assets/img/observership.jpeg';
import Observershipvector from './assets/img/observer-vector.png';
import Kirti from './assets/img/Dr.-Kriti.jpg';
import Rakhi from './assets/img/Dr.Rakhi_.jpg';
import Shimi from './assets/img/Dr.Shimi_.jpg';
import Tour from './assets/img/labtour-1024x76.jpeg';
import Histopathology from './assets/img/microorganism.png';
import Genetics from './assets/img/dna.png';
import Clinical  from './assets/img/clinical.png';
import Special from './assets/img/chemistry.png';
import Immunoassay from './assets/img/antibody.png';
import Pathology from './assets/img/cancer-cell.png';
import RD from './assets/img/medical-research.png';
import Haematology from './assets/img/blood-test.png';
import Micro from './assets/img/microbiology.png';
import Molecular from './assets/img/molecules.png';
import avatar from './assets/img/avatar.png';
import labTour from './assets/img/labtour.jpeg';
import labTour1 from './assets/img/labtour1.jpg';
import labTour2 from './assets/img/labtour2.jpeg';
import labTour3 from './assets/img/labtour3.jpeg';
import labTour4 from './assets/img/labtour4.jpeg';
import labTour5 from './assets/img/labtour5.jpeg';
import labTour6 from './assets/img/labtour6.jpeg';
import labTour7 from './assets/img/labtour7.jpeg';
import labTour8 from './assets/img/labtour8.jpeg';
import labTour9 from './assets/img/labtour9.png';
import labTourVector from './assets/img/labtour.png';
import academy from './assets/img/academy.jpeg';
import academicvector from './assets/img/academic.png';
import Medtalk1 from './assets/img/medtalk-1.jpg';
import Medtalk2 from './assets/img/medtalk2.jpg';
import Internshipprogram from './assets/img/Internshipprogram.jpg';
import Internshipvector from './assets/img/Internshipvector.png';
import Trophy from './assets/img/trophy-award.png';
import Star from './assets/img/star.png';
import Icon1 from './assets/img/icon.png';
import Icon2 from './assets/img/icon1.png';
import Icon3 from './assets/img/icon2.png';
import Icon4 from './assets/img/icon3.png';
import Icon5 from './assets/img/icon4.png';
import Icon6 from './assets/img/icon5.png';
import Glimps1 from './assets/img/glimpses-event-img-1.jpg';
import Glimps2 from './assets/img/glimpses-event-img-2.jpg';
import Glimps3 from './assets/img/glimpses-event-img-3.jpg';
import Glimps4 from './assets/img/glimpses-event-img-4.jpg';
import Glimps5 from './assets/img/glimpses-event-img-5.jpg';
import Glimps6 from './assets/img/glimpses-event-img-6.jpg';
import Glimps7 from './assets/img/glimpses-event-img-7.jpg';
import Glimps8 from './assets/img/glimpses-event-img-8.jpg';
import Glimps9 from './assets/img/glimpses-event-img-9.jpg';
import Glimps10 from './assets/img/glimpses-event-img-10.jpg';
import Glimps11 from './assets/img/glimpses-event-img-11.jpg';
import Glimps12 from './assets/img/glimpses-event-img-12.jpg';
import Glimps13 from './assets/img/glimpses-event-img-13.jpg';
import Glimps14 from './assets/img/glimpses-event-img-14.jpg';
import Glimps15 from './assets/img/glimpses-event-img-15.jpg';
import Glimps16 from './assets/img/glimpses-event-img-16.jpg';
import Glimps17 from './assets/img/glimpses-event-img-17.jpg';
import Glimps18 from './assets/img/glimpses-event-img-18.jpg';
import Anita from './assets/img/Anita.jpeg';
import Francisco from './assets/img/Francisco.jpg';
import Neeraj from './assets/img/Neeraj.jpeg';
import Prabal from './assets/img/Prabal.jpeg'
import Unnikrishnan from './assets/img/Unnikrishnan.jpeg';
import Amita from './assets/img/Amita.jpeg';
import Lahane from './assets/img/Lahane.jpeg';
import Vijay from './assets/img/Vijay.jpeg';
import Gustad from './assets/img/Gustad.jpeg';
import Scholorprogram from './assets/img/scholor.jpeg';
import Labprogram from './assets/img/lab-tour.jpg';
import Observerprogam from './assets/img/observer.jpeg';
import BuildingProgram from './assets/img/talk-scaled.jpg';
import InternProgram from './assets/img/intern.jpg';
import AcademinProgram from './assets/img/help.jpg';
import BannerVector from './assets/img/banner-img-vector-1.png';
import InternImage from './assets/img/intern.jpeg';
import LabImage from './assets/img/lab.jpeg';
import LabIcon from './assets/img/labb.png';
import BookIcon from './assets/img/book.png';
import ScholorshipIcon from './assets/img/scholorship.png';
import GroupIcon from './assets/img/group.png';
import Homescholor from './assets/img/scholor.jpeg';
import Homeobserver from './assets/img/observer.jpeg';
import Homelab from './assets/img/lab-tour.jpeg';
import Homebuilding from './assets/img/building.jpeg';
import Homeintern from './assets/img/Homeintern.jpeg';
import Homeacademic from './assets/img/Homeacademic.jpeg';
import Meena from './assets/img/Dr.Meenal.jpeg';
import Pallavi from './assets/img/Dr.pallavi.jpeg';
import Praveen from './assets/img/Dr.Praveen.jpeg';
import Mohanty from './assets/img/Dr.Mohanty.jpeg';
import Divya from './assets/img/Dr.Divya.jpeg';
import Rajat from './assets/img/Dr.Arvind.jpeg';
import Ravi from './assets/img/Dr.ravi.jpeg';
import Anuradha from './assets/img/Dr.Anuradha.jpeg';
import ArvindKrishnamurthy from './assets/img/krishna.png';
import NeelamMohan from './assets/img/Dr.Neelm.jpeg';
import ShanazKhodaiji from './assets/img/Dr.Shanaz.jpeg';
import JaswinderKaur  from './assets/img/Jawinder.png';
import MeenaDesai from './assets/img/Dr.Meena.jpeg';
import RajivYadav from './assets/img/Dr.Rajeev.jpeg';
import Pradeep from './assets/img/Dr.Pradee.jpeg';
import Pratik from './assets/img/Dr.Prateek.jpeg';
import Vivek from './assets/img/Dr.Vivek.jpeg';
import Grant from './assets/winners/Research-Grant-scaled.jpg';
import winner1 from "./assets/winners/INTERN-ASD.jpg";
import winner2 from "./assets/winners/internships.jpg";
import winner3 from "./assets/winners/PG-ASD.jpg";
import winner4 from './assets/winners/PG.jpg';
import winner5 from './assets/winners/PG-ASD.jpg';
import winner6 from './assets/winners/1ST-ASD.jpg';
import winner7 from './assets/winners/1ST-MBBS.jpg';
import winner8 from './assets/winners/2ND-ASD.jpg';
import winner9 from './assets/winners/2ND-MBBS.jpg';
import winner10 from './assets/winners/3RD-ASD.jpg';
import winner11 from "./assets/winners/4TH-ASD.jpg";
import winner12 from "./assets/winners/4TH.jpg";
import Banner1 from "./assets/img/11.jpeg";
import Banner2 from "./assets/img/22.jpeg";
import Banner3 from "./assets/img/Banner3.jpeg";
import Banner4 from "./assets/img/Banner.jpeg";
import Password from "./assets/img/password.jpg";
import Anitasuryanarayan from "./assets/img/anitasuryanarayan.jpg";

// Export them as an object
const Images = {
  Logo,
  Password,
  Grant,
  Banner1,
  Anitasuryanarayan,
  Banner2,
  Banner3,
  Banner4,
  winner1,
  winner2,
  winner3,
  winner4,
  winner5,
  winner6,
  winner7,
  winner8,
  winner9,
  winner10,
  winner11,
  winner12,
  HomeBanner,
  BannerVector,
  InternImage,
  LabImage,
  Metropolis,
  ArvindKrishnamurthy,
  NeelamMohan,
  ShanazKhodaiji,
  JaswinderKaur,
  MeenaDesai,
  RajivYadav,
  Pradeep,
  Pratik,
  Vivek,
  Homescholor,
  Homeobserver,
  Homeintern,
  Homelab,
  Homeacademic,
  Homebuilding,
  ScholorshipImage,
  ScholorVector,
  LabIcon,
  BookIcon,
  ScholorshipIcon,
  GroupIcon,
  Arrow,
  Dummy,
  Academic,
  Poster,
  Publication,
  Extra,
  Community,
  StylishArrow,
  Play,
  Doctor,
  Facebook,
  LinkedIn,
  Twitter,
  Instagram,
  Research,
  Students,
  Aspirational,
  Test1,
  Test2,
  Test3,
  Test4,
  Test5,
  Plus,
  Minus,
  Search,
  Doctors,
  Location,
  Internship,
  Application,
  Signup,
  Reset,
  Thanks,
  Observership,
  Observershipvector,
  Kirti,
  Rakhi,
  Shimi,
  Tour,
  Histopathology,
  Genetics,
  Molecular,
  Clinical,
  Special,
  Immunoassay,
  Pathology,
  RD,
  labTourVector,
  Meena,
  Pallavi,
  Praveen,
  Mohanty,
  Divya,
  Rajat,
  Ravi,
  Anuradha,
  Haematology,
  Micro,
  avatar,
  labTour,
  labTour1,
  labTour2,
  labTour3,
  labTour4,
  labTour5,
  labTour6,
  labTour7,
  labTour8,
  labTour9,
  academy,
  academicvector,
  Medtalk1,
  Medtalk2,
  Internshipprogram,
  Internshipvector,
  Trophy,
  Star,
  Icon1,
  Icon2,
  Icon3,
  Icon4,
  Icon5,
  Icon6,
  Glimps1,
  Glimps2,
  Glimps3,
  Glimps4,
  Glimps5,
  Glimps6,
  Glimps7,
  Glimps8,
  Glimps9,
  Glimps10,
  Glimps11,
  Glimps12,
  Glimps13,
  Glimps14,
  Glimps15,
  Glimps16,
  Glimps17,
  Glimps18,
  Anita,
  Francisco,
  Prabal,
  Neeraj,
  Unnikrishnan,
  Amita,
  Lahane,
  Vijay,
  Gustad,
  Scholorprogram,
  Labprogram,
  Observerprogam,
  BuildingProgram,
  InternProgram,
  AcademinProgram,
};

export default Images;
